import React from 'react';
import { bool, func, /*node,*/ number, string } from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import classNames from 'classnames';

import css from './SearchFiltersPrimary.module.css';
import { useLocation } from 'react-router-dom';

const SearchFiltersPrimaryComponent = props => {
  const {
    rootClassName,
    className,
    children,
    // sortByComponent,
    listingsAreLoaded,
    resultsCount,
    searchInProgress,
    isSecondaryFiltersOpen,
    toggleSecondaryFiltersOpen,
    selectedSecondaryFiltersCount,
    // isBookings,
    urlQueryParams,
  } = props;

  const location = useLocation();

  const search = new URLSearchParams(location.search);

  const isBookings = search.get('pub_listingtype') === 'requirement';

  const hasNoResult = listingsAreLoaded && resultsCount === 0;
  const classes = classNames(rootClassName || css.root, className);

  const toggleSecondaryFiltersOpenButtonClasses =
    isSecondaryFiltersOpen || selectedSecondaryFiltersCount > 0
      ? css.searchFiltersPanelOpen
      : css.searchFiltersPanelClosed;
  const toggleSecondaryFiltersOpenButton = toggleSecondaryFiltersOpen ? (
    <button
      className={toggleSecondaryFiltersOpenButtonClasses}
      onClick={() => {
        toggleSecondaryFiltersOpen(!isSecondaryFiltersOpen);
      }}
    >
      <FormattedMessage
        id="SearchFiltersPrimary.moreFiltersButton"
        values={{ count: selectedSecondaryFiltersCount }}
      />
    </button>
  ) : null;

  const plural = resultsCount !== 1 ? 'professionals' : 'professional';
  const bookingsPlural = resultsCount !== 1 ? 'bookings' : 'booking';

  return (
    <div className={classes}>
      <div className={css.searchOptions}>
        {listingsAreLoaded ? (
          <div className={css.searchResultSummary}>
            {!isBookings && resultsCount !== 0 && plural ? (
              <h1 className={css.filterHeading}>
                We've found {resultsCount} communication {plural}
              </h1>
            ) : null}
            {isBookings && resultsCount !== 0 && plural ? (
              <div>
                <h1 className={css.filterHeading}>
                  We've found {resultsCount} {bookingsPlural}
                </h1>
                <p>
                  <FormattedMessage id="SearchFiltersPrimary.bookingResultsIntro" />
                </p>
              </div>
            ) : null}
          </div>
        ) : null}
        {/* {sortByComponent} */}
      </div>
      {!hasNoResult && !isBookings ? (
        <p>
          <FormattedMessage id="SearchFiltersPrimary.resultsIntro" />
        </p>
      ) : null}
      {!isBookings ? (
        <div className={css.filters}>
          {children}
          {toggleSecondaryFiltersOpenButton}
        </div>
      ) : (
        <div className={css.filters}>{children}</div>
      )}
      {hasNoResult ? (
        <div className={css.noSearchResults}>
          <p>
            {isBookings ? (
              <FormattedMessage id="SearchFiltersPrimary.noResultsBookings" />
            ) : (
              <FormattedMessage id="SearchFiltersPrimary.noResults" />
            )}
          </p>
        </div>
      ) : null}
      {searchInProgress ? (
        <div className={css.loadingResults}>
          <FormattedMessage id="SearchFiltersPrimary.loadingResults" />
        </div>
      ) : null}
    </div>
  );
};

SearchFiltersPrimaryComponent.defaultProps = {
  rootClassName: null,
  className: null,
  resultsCount: null,
  searchInProgress: false,
  isSecondaryFiltersOpen: false,
  toggleSecondaryFiltersOpen: null,
  selectedSecondaryFiltersCount: 0,
  // sortByComponent: null,
};

SearchFiltersPrimaryComponent.propTypes = {
  rootClassName: string,
  className: string,
  listingsAreLoaded: bool.isRequired,
  resultsCount: number,
  searchInProgress: bool,
  isSecondaryFiltersOpen: bool,
  toggleSecondaryFiltersOpen: func,
  selectedSecondaryFiltersCount: number,
  // sortByComponent: node,
};

const SearchFiltersPrimary = SearchFiltersPrimaryComponent;

export default SearchFiltersPrimary;
